import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '@components/Comman/Header';
import { Table, Space, Switch } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useSelector, useDispatch } from 'react-redux';
import { getAllSmsTemplates, updateSmsTemplate } from '../../actions/business';
import SearchFilter from '@components/Comman/TableFilter/SearchFilter';
import PageTitle from '@components/Comman/PageTitle';

interface DataType {
    id:number
    title: string;
    body: string;
    acitve: boolean;
}

const SmsTemplates = () => {
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state: any) => state?.General);
    const navigate = useNavigate();

    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const userData = useSelector((state: any) => state?.Auth?.user);
    const userRoleId = userData?.data?.roleId;
    
    const columns: ColumnsType<any> = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            sorter: (a, b) => a.title.localeCompare(b.title),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Body',
            dataIndex: 'body',
            key: 'body',
            sorter: (a, b) => a.title.localeCompare(b.title),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Status',
            dataIndex: 'active',
            key: 'active',
            render: ( _ , record) => {
                console.log("Template.active",record)
                return (
                    <Switch
                        checked={record?.active}
                        style={{
                            backgroundColor: record?.active ? '#F47523' : '#a9a9a9', // Green when active, red when inactive
                        }}
                        onChange={(checked) => handleStatusChange(checked, record)}
                    />
                )
            },
            align: 'center',
            width: 100,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Link to={'/super-admin/edit-sms-template'} state={record}>
                        <EditOutlined />
                    </Link>
                </Space>
            ),      
            align: 'center',
            width: 100,
        },
    ];

    // ********Fetch  All Sms Template***********//
    const handleSmsTemplate = (payload:any)=>{
        dispatch(
            getAllSmsTemplates(payload, (res: any) => {
                if (res?.status === 200) {
                    setData(res?.data);
                    setPagination(res?.pagination);
                }
            })
        );
    }

    useEffect(() => {
        const payload = { limit: pageSize, page, role: userRoleId };
        handleSmsTemplate(payload);
    }, [page, pageSize, dispatch]);




    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleStatusChange = (checked : any,  record : any) =>{
            record.active = checked;

            dispatch(
                updateSmsTemplate(record,(resp: any) => {
                    if (resp) {
                        navigate('/super-admin/sms');
                    }
                })
            );
    }



    const handleSearch =(data:any)=> {
        let payload = {
            ...data,
            search: data?.search,
            limit: pageSize, 
            page, 
            role: userRoleId
        }
        handleSmsTemplate(payload);       
    }

    const activeFilter  = [
        { value: "activesms", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];

    return (
        <div>
            <Header pagTitle="Sms Templates" />
            <div className="contentBody">
                <div className="bodycard">
                        <PageTitle buttonLabel='Add Template' pagTitle="Sms Templates" button={true} buttonLink={'/super-admin/add-sms-template'} />
                        <div className='pl-24' style={{ float: "right" }}>
                                   
                        </div>
                        <SearchFilter
                            filterList={activeFilter}
                            searchTitle="Template Title"
                            onSearch={(searchValue) => {
                                // Handle the search value here
                                handleSearch(searchValue)
                            }}
                        />
                    <div className="cardContentbody">
                        <div className="responsivetable">
                            <Table
                                size='small'
                                columns={columns}
                                dataSource={data}
                                loading={isLoading}
                                pagination={{
                                    total: pagination?.totalItems || 0,
                                    pageSize,
                                    current: page,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['20', '50'],
                                }}
                                scroll={{ y: 264, x: 800 }}
                                onChange={handleTableChange}
                                rowKey='id'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SmsTemplates;

